import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { BodenvegetationZeile, hatHumusForm, hatVegetationsformengruppe, isString, schichtLabel, trackByIndex } from 'src/app/data-model';

@Component({
    standalone: false,
    selector: 'bp-vegetationsaufnahme',
    templateUrl: './vegetationsaufnahme.component.html',
    styleUrls: ['./hl-area.component.css', '../bohrpunkt-boden/bohrpunkt-boden.component.css'],
    
})
export class VegetationsaufnahmeComponent extends HlAreaComponent {
  trackByIndex = trackByIndex;
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;
	schichtLabel = schichtLabel;
	isString = isString;

  onAddVegetationsZeile() {
    this.data?.bodenvegetation.aufnahme.vegetationen.push({} as BodenvegetationZeile);
  }

  onRemoveVegetationsZeile(i: number) {
    this.data?.bodenvegetation.aufnahme.vegetationen.splice(i, 1);
  }
	
	schichten(): ('b1'|'b2'|'str'|'kr1'|'kr2'|'m')[] {
		const schichten = new Set<'b1'|'b2'|'str'|'kr1'|'kr2'|'m'>();
		this.data.bodenvegetation.aufnahme.vegetationen.forEach((bv: BodenvegetationZeile) => {
			if (bv.schicht) schichten.add(bv.schicht);
		});
		return Array.from(schichten).sort();
	}
}
